import {Auditable} from "../utility";
import {QueryParams} from "../http";
import {SortParams} from "../api";

export interface NotificationConfig extends Auditable {
    name: string;
    toEmails: string;
    ccEmails: string;
    emailSubject: string;
    emailBody: string;
    smsBody: string;
}

export const DefaultNotificationConfigQueryParams: QueryParams = {
    name: "",
};

export const DefaultNotificationConfigSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
